(function() {
    'use strict';

    angular
        .module('adminApp')
        .run(runFunc);

    //function runFunc($templateCache, $http, $q, $rootScope, Path, MasterLayoutService) {
    function runFunc($q, $rootScope,Path) {
        // $q.defer() allow us to delay processing until they are done processing.
        $rootScope.initPortalLoader = $q.defer();
        //var masterTemplateDataDefer = $q.defer();

        angular.element('.no-js-wrapper').remove();
        Path.init('/api/admin/admin/structure/', '/api');
        $rootScope.initPortalLoader.resolve();

        //var navUrl = '/api/admin/rms/structure/navbar';
        //Path.setMasterLayoutDataPath(navUrl);
        //$http.get(navUrl).then(function (res) {
        //    if (res.data.success) {
        //        MasterLayoutService.set(res.data.structure);
        //    }
        //    masterTemplateDataDefer.resolve();
        //}, function () {
        //    masterTemplateDataDefer.resolve();
        //});
        //
        //$q.all([masterTemplateDataDefer.promise]).then(function () {
        //    $rootScope.initPortalLoader.resolve();
        //});

    }
})();